/* global gtag */
import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import { FaCircleCheck } from "react-icons/fa6";
import wave from "../assets/images/wave.webp";
import WOW from "wowjs";

import GetInTouch from "../components/GetInTouch";
import whoWeAreBg from "../assets/images/about-bg.webp";

import logo from "../assets/images/ionia-logo.webp";
import ExportingForCountries from "../components/ExportingForCountries";
import Certificates from "../components/Certificates";
import Patent from "../components/Patent";

import ScrollToTop from "../components/ScrollToTop";
import axios from "axios";
import phscalesec from "../assets/images/aboutus/ph-scale-sec.webp";
import loader from "../assets/loader.gif";
import PhLevel from "../components/PhLevel";
import HomeOurProducts from "../components/PageSections/HomeOurProducts";
import HomeWhyPureIonia from "../components/PageSections/HomeWhyPureIonia";
import HomeGoogleReviews from "../components/PageSections/HomeGoogleReviews";
import HomeBannerSlider from "../components/PageSections/HomeBannerSlider";

export default function Home() {
  const [contactData, setContactData] = useState({
    name: "Dear",
    phone: "",
    header: "Pure Ionia Enquiry Home Popup",
  });
  const [isContactValid, setIsContactValid] = useState(true);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  const [modalShow, setModalShow] = useState(false);
  useEffect(() => {
    if (!sessionStorage.getItem("id")) {
      setTimeout(() => {
        setModalShow(true);
      }, 7000);
    }
  }, []);

  const handleClose = () => {
    setModalShow(false);
  };
  const fetchAllocation = async () => {
    const obj = {
      notes: "From Website",
      processName: "Default Process",
      assignedTo: "+919654455530",
    };
    obj.customer = {
      name: contactData.name,
      phoneNumber: contactData.phone,
    };
    try {
      await axios
        .post("https://api.runo.in/v1/crm/allocation", obj, {
          headers: {
            "Content-Type": "application/json",
            "Auth-Key": "MWIybG41b2h5Mm9nNXFkM3U=",
          },
        })
        .then((data) => {
          console.log(data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
      console.log("Error submitting form", err);
    }
  };

  const handleSubmitform = async (e) => {
    e.preventDefault();
    if (contactData.phone === "" || contactData.phone.length < 10) {
      setIsContactValid(false);
      return;
    }
    setIsDisable(true);
    fetchAllocation();
    // await axios
    // 	.post(
    // 		// "https://api.interakt.ai/v1/public/message/",
    // 		{
    // 			countryCode: "+91",
    // 			phoneNumber: contactData.phone,

    // 			callbackData: "hello",
    // 			type: "Template",
    // 			template: {
    // 				name: "welcome_message",
    // 				languageCode: "en",
    // 				headerValues: ["Dear"],
    // 				fileName: "file_name.pdf",
    // 				bodyValues: ["body_variable_value"],
    // 			},
    // 		},
    // 		{
    // 			headers: {
    // 				Authorization:
    // 					"Basic V1V0SE5wbW5RdmFsX24yMXppV0ttaGQzOWpnTTk1bnZ0Ym5iNjVuLTlrczo=",
    // 			},
    // 		}
    // 	)
    // 	.then((data) => {
    // 		if (data.data.result) {
    // 			sessionStorage.setItem("id", data.data.id);
    // 			setIsFormSubmitted(true);
    // 			setIsDisable(true);
    // 		}
    // 	});
    setIsContactValid(true);
    await axios.post("https://commonapi.quickgst.in/event/email", contactData);
    // setIsContactValid(true);
    // setIsDisable(false);
    sessionStorage.setItem("id", true);
    setIsFormSubmitted(true);
    setIsDisable(true);
  };

  return (
    <Layout>
      <ScrollToTop />
      <Modal
        size="md"
        aria-labelledby="connect-us"
        centered
        show={modalShow}
        onHide={handleClose}
        backdropClassName="connect__overlay"
      >
        <Modal.Header closeButton>
          <picture>
            <source srcSet={logo} type="image/webp" />
            <img src={logo} alt="Fallback Image" className="connect_logo" />
          </picture>
        </Modal.Header>
        <Modal.Body>
          {!isFormSubmitted ? (
            <div className="connect_box">
              <h5>
                Want to know more about the product?
                <span>
                  Just enter your <strong>Whatsapp</strong> number
                </span>
              </h5>
              <Form onSubmit={handleSubmitform}>
                <div className="connect_input">
                  <Form.Group controlId="phone" className="inputbox">
                    <Form.Control
                      type="tel"
                      placeholder="Enter phone"
                      value={contactData.phone}
                      onChange={(e) =>
                        setContactData({
                          ...contactData,
                          phone: e.target.value,
                        })
                      }
                      maxLength="10"
                      name="phone"
                    />
                    {isDisable && (
                      <picture>
                        <source srcSet={loader} type="gif/image" />
                        <img
                          src={loader}
                          alt="loader"
                          className="loader ms-2"
                        />
                      </picture>
                    )}
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={isDisable}
                    className="submit"
                    onClick={(e) => {
                      handleSubmitform(e);
                      if (typeof gtag === "function") {
                        gtag("event", "conversion", {
                          send_to: "AW-437309363/JRVdCMOlsMkDELOfw9AB",
                        });
                      } else {
                        console.error(
                          "gtag is not defined. Make sure it is properly included in your project."
                        );
                      }
                    }}
                  >
                    Connect
                  </Button>
                </div>
                {!isContactValid && (
                  <Form.Text className="text-muted">
                    <span className="text-danger">
                      Please enter valid number...
                    </span>
                  </Form.Text>
                )}
              </Form>
            </div>
          ) : (
            <div className="connect_box text-center">
              <FaCircleCheck
                style={{
                  color: "#12c665",
                  fontSize: "60px",
                  marginBottom: "20px",
                }}
              />
              <h5 className="m-0">
                Thank you for choosing <span>IONIA!</span>
              </h5>
              <p>We will get back to your soon.</p>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <HomeBannerSlider />

      <section
        className="who_we_are__wrapper"
        style={{ backgroundImage: `url(${whoWeAreBg})` }}
      >
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <div className="title__wrap">
                <h2>
                  Equip your whole family with the shield of accurate
                  <br />
                  <span className="text-center w-100">pH balanced water.​</span>
                </h2>
                <img src={wave} alt="Wave" className="wave__img" height={50} />
              </div>
              <p>
                By providing your family with accurate pH balanced water through
                the use of a water ionizer, you're offering them a proactive and
                convenient way to experience these diverse health benefits.
              </p>
              <ul
                id="image"
                className="product_detail_info_list column_count_2"
              >
                <li>Optimal Hydration</li>
                <li>Enhanced Nutrient Absorption</li>
                <li>Improved Digestion</li>
                <li>Boosted Immune System</li>
                <li>Detoxification Support</li>
                <li>Energy Boost</li>
                <li>Bone Health</li>
                <li>Reduced Acidity</li>
                <li>Anti-Aging Benefits</li>
                <li>Overall Wellness</li>
              </ul>
            </Col>
            <Col
              md={5}
              className="offset-md-1
              wow
              zoomIn
              center"
              data-wow-delay="0.5s"
            >
              <picture>
                <source srcSet={phscalesec} type="image/webp" />
                <img
                  src={phscalesec}
                  alt="Pure ionia"
                  width={"100%"}
                  height={"100%"}
                  className="w-100 h-100s about_image mt-5 mt-md-0"
                />
              </picture>
            </Col>
          </Row>
        </Container>
      </section>

      <HomeOurProducts />

      <PhLevel />

      <HomeWhyPureIonia />

      <HomeGoogleReviews />

      <section className="different_php_level">
        <Container>
          <Row>
            <Col md={12}>
              <div className="title__wrap regular center_aligned">
                <h3>About IONIA Korea</h3>
                <h2>Trusted Today Healthier Tomorrow</h2>
              </div>
            </Col>
          </Row>
          <Row className=" justify-content-md-end justify-content-start position-relative">
            <Col md={5} className="content__box">
              <p>
                <strong>IONIA CO., LTD.</strong> is a company specialised in
                developing and supplying a variety of echo friendly health
                appliances including alkaline water ionizers, IPL's and cold
                dispenser manufactured in the state-of-the-art facilities
                equipped with highly reliable and globally competitive
                manufacturing systems.
              </p>
              <p>
                We are striving to secure the independent R&D technology by
                establishing a technology R&D center and shipping our products
                not only to large and medium sized companies in Korea on an
                OEM/ODM basis but a lso to the customers in more than 40
                countries in the world by making a ceaseless effort in
                developing various kinds of new technologies and new products.
              </p>
              <p>
                We promise all of you that we will grow step by step to be a
                world class company making an unlimited impression on customers
                through constant technology innovation based on environment
                products and health products under our own Pure ionia brand.
              </p>
            </Col>
            <Col md={7}>
              <div className="video_box">
                <iframe
                  src="https://www.youtube.com/embed/VtuISBFdVbI"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                  height="100%"
                ></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <ExportingForCountries />

      <Patent />

      <Certificates />

      <GetInTouch />
    </Layout>
  );
}
